// The frosted-glass card the three Flutter auth screens share:
// a full-bleed background photo, then a blurred, translucent, rounded panel
// centred over it (BackdropFilter blur 10, black @10%, radius 20, shadow).
// Width is 80% of the screen but capped at 480 so it stays phone-shaped.

import React from 'react';
import { Box } from '@mui/material';
import { BACKGROUND_IMAGE } from '../../../core/devices/deviceAssets';

export default function GlassCard({ children }) {
  return (
    <Box
      sx={{
        height: '100%',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundImage: `url(${BACKGROUND_IMAGE})`,
        backgroundSize: '100% 100%',
        backgroundPosition: 'center',
      }}
    >
      <Box
        sx={{
          width: 'min(80vw, 480px)',
          maxHeight: '90vh',
          overflowY: 'auto',
          p: 2.5,
          borderRadius: '20px',
          bgcolor: 'rgba(0,0,0,0.10)',
          backdropFilter: 'blur(10px)',
          WebkitBackdropFilter: 'blur(10px)',
          boxShadow: '4px 4px 10px 6px rgba(0,0,0,0.2)',
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
